import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Box, Grid, Button } from '@mui/material';
import Header from './Header';

function AdminPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Header title={t('common.admin')} />

            <Container sx={{ mt: 4 }}>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} sm={6} md={4}>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ p: 4 }}
                            onClick={() => navigate('/admin/manage-users')}
                        >
                            {t('common.manageUsers')}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ p: 4 }}
                            onClick={() => navigate('/admin/manage-smart-devices')}
                        >
                            {t('common.manageSmartDevices')}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default AdminPage;